var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhsFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icons8-facebook"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 2.5C9.48044 2.5 7.06408 3.50089 5.28249 5.28249C3.50089 7.06408 2.5 9.48044 2.5 12C2.5 14.5196 3.50089 16.9359 5.28249 18.7175C7.06408 20.4991 9.48044 21.5 12 21.5C14.5196 21.5 16.9359 20.4991 18.7175 18.7175C20.4991 16.9359 21.5 14.5196 21.5 12C21.5 9.48044 20.4991 7.06408 18.7175 5.28249C16.9359 3.50089 14.5196 2.5 12 2.5Z",
    fill: "#039BE5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.286 14.5179H15.7445L16.1305 12.0204H13.2855V10.6554C13.2855 9.61789 13.6245 8.69789 14.595 8.69789H16.1545V6.51839C15.8805 6.48139 15.301 6.40039 14.206 6.40039C11.9195 6.40039 10.579 7.60789 10.579 10.3589V12.0204H8.22852V14.5179H10.579V21.3824C11.0445 21.4524 11.516 21.4999 12 21.4999C12.4375 21.4999 12.8645 21.4599 13.286 21.4029V14.5179Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhsFacebook);
export default __webpack_public_path__ + "static/media/WHSFacebook.c2cee091cf857e8bae52dfdfd8247403.svg";
export { ForwardRef as ReactComponent };